import { TimeSlotType, TimeSpan } from 'fitbeat.models';

export class TimeType {
  constructor(
    public readonly timeSpan: TimeSpan,
    public readonly type: TimeSlotType,
  ) { /* no-op */ }

  public isDateAndTypeInThisSlot(date: Date, type: TimeSlotType): boolean {
    if (type !== this.type) {
      return false;
    }
    return this.isDateInThisSlot(date);
  }

  public isDateInThisSlot(date: Date): boolean {
    const startDate = TimeSpan.generateDateFromHHMMString(this.timeSpan.start);
    const endDate = TimeSpan.generateDateFromHHMMString(this.timeSpan.end);
    return date.getTime() >= startDate.getTime() && date.getTime() < endDate.getTime();
  }
}
